import React from 'react'
import * as S from './BasketNavigation.styled'
import { useRouter } from 'next/router'
import { useMediaQuery } from 'react-responsive'
import { useFavoritesCount } from 'src/features/favorite/model/favorite-storage'
import { useBasketActualCount, useBasketCount } from '@entities/basket/hooks'
import { useThreshold } from 'src/features/order/model/threshold'

const BasketNavigation = () => {
    const likedGoodsCount = useFavoritesCount()
    const basketCount = useBasketCount()
    const basketActualCount = useBasketActualCount()
    const router = useRouter()
    const threshold = useThreshold()
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1180px)' })

    const showBasket = () => {
        if (basketCount > 0) router.push('/order/basket')
    }
    const clickLiked = () => {
        if (likedGoodsCount > 0) router.push('/catalog/liked')
    }

    return (
        <S.Container>
            <S.Icons>
                <S.Like
                    onClick={clickLiked}
                    isDisabled={likedGoodsCount === 0}
                    cursor={likedGoodsCount > 0 ? 'pointer' : 'default'}>
                    {likedGoodsCount > 0 && <S.LikedCount>{likedGoodsCount}</S.LikedCount>}
                </S.Like>
                <S.Basket data-basket-button onClick={showBasket} isDisabled={!basketActualCount > 0}>
                    {basketActualCount > 0 ? (
                        <S.PositionsCount>{basketActualCount}</S.PositionsCount>
                    ) : (
                        <S.PositionsCount>{basketCount > 0 ? basketCount : ''}</S.PositionsCount>
                    )}
                </S.Basket>
            </S.Icons>
            {!isTabletOrMobile && basketActualCount > 0 ? (
                <S.BasketSumContainer onClick={showBasket}>
                    {(threshold.sums?.sumStock || 0) > 0 ? (
                        <S.SumContainer>
                            <S.SumTitle>Самовывоз</S.SumTitle>
                            <S.Sum>{`${threshold.sums.sumStock.toLocaleString('ru-RU')} ₽`}</S.Sum>
                        </S.SumContainer>
                    ) : (
                        <S.SumContainer>
                            <S.SumTitle>Самовывоз</S.SumTitle>
                            <S.Sum>{`от ${threshold.sums?.sumMin?.toLocaleString('ru-RU') || 0} ₽`}</S.Sum>
                        </S.SumContainer>
                    )}
                    {(threshold.sums?.sumStock || 0) > 0 && (threshold.sums?.sumDelivery || 0) > 0 ? (
                        <S.HRContainer>
                            <S.Sum>/</S.Sum>
                        </S.HRContainer>
                    ) : (
                        <React.Fragment />
                    )}

                    {(threshold.sums?.sumDelivery || 0) > 0 && (
                        <S.SumContainer>
                            <S.SumTitle>Доставка</S.SumTitle>
                            <S.Sum>{`${threshold.sums.sumDelivery.toLocaleString('ru-RU')} ₽`}</S.Sum>
                        </S.SumContainer>
                    )}
                </S.BasketSumContainer>
            ) : (
                <React.Fragment />
            )}
        </S.Container>
    )
}

BasketNavigation.propTypes = {}

export default BasketNavigation
